import { populate } from "populate";

const raw = {
  handleResize: true,
  width: 0,
  height: 0,
  x: 0,
  y: 0,
  list: [
    {
      id: "1",
      type: "Container",
      name: "root",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "",
      data: ""
    },
    {
      id: "2",
      type: "Container",
      name: "backgrounds",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "3",
      type: "Container",
      name: "nodesContainer",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "4",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "5",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "1",
      data: ""
    },
    {
      id: "6",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_1",
      parent: "2",
      data: ""
    },
    {
      id: "7",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1350,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_2",
      parent: "2",
      data: ""
    },
    {
      id: "8",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2700,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_3",
      parent: "2",
      data: ""
    },
    {
      id: "9",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4050,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_4",
      parent: "2",
      data: ""
    },
    {
      id: "10",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5400,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_5",
      parent: "2",
      data: ""
    },
    {
      id: "11",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6750,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_6",
      parent: "2",
      data: ""
    },
    {
      id: "12",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8100,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_7",
      parent: "2",
      data: ""
    },
    {
      id: "13",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9450,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "world2_8",
      parent: "2",
      data: ""
    },
    {
      id: "14",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 271,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "15",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 408,
      y: 355,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "16",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 536,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "17",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 668,
      y: 313,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "18",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 770,
      y: 386,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "19",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 838,
      y: 473,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "20",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 937,
      y: 542,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "21",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1055,
      y: 602,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "22",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1200,
      y: 633,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "23",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1287,
      y: 547,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "24",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1272,
      y: 424,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "25",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1271,
      y: 309,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "26",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1362,
      y: 217,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "27",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1490,
      y: 206,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "28",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1611,
      y: 257,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "29",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1680,
      y: 353,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "30",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1725,
      y: 458,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "31",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1778,
      y: 556,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "32",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1866,
      y: 632,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "33",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1999,
      y: 648,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "34",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2116,
      y: 579,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "35",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2184,
      y: 477,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "36",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2215,
      y: 363,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "37",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2285,
      y: 270,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "38",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2405,
      y: 214,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "39",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2545,
      y: 225,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "40",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2659,
      y: 297,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "41",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2700,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "42",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2761,
      y: 500,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "43",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2842,
      y: 586,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "44",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2967,
      y: 637,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "45",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3103,
      y: 611,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "46",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3178,
      y: 519,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "47",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3229,
      y: 406,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "48",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3286,
      y: 313,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "49",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3391,
      y: 244,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "50",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3527,
      y: 245,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "51",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3626,
      y: 310,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "52",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3651,
      y: 408,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "53",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3675,
      y: 508,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "54",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3735,
      y: 602,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "55",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3860,
      y: 648,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "56",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3969,
      y: 583,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "57",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3993,
      y: 489,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "58",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4012,
      y: 385,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "59",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4071,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "60",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4194,
      y: 292,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "61",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4295,
      y: 360,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "62",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4399,
      y: 426,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "63",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4520,
      y: 370,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "64",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4629,
      y: 329,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "65",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4759,
      y: 343,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "66",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4823,
      y: 446,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "67",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4851,
      y: 552,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "68",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4943,
      y: 631,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "69",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5079,
      y: 622,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "70",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5159,
      y: 537,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "71",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5199,
      y: 439,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "72",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5246,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "73",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5365,
      y: 284,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "74",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5489,
      y: 340,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "75",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5635,
      y: 399,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "76",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5794,
      y: 383,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "77",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5946,
      y: 367,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "78",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6062,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "79",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6144,
      y: 559,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "80",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6252,
      y: 629,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "81",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6397,
      y: 631,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "82",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6471,
      y: 545,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "83",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6481,
      y: 422,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "84",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6488,
      y: 304,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "85",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6570,
      y: 213,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "86",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6712,
      y: 209,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "87",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6830,
      y: 251,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "88",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6907,
      y: 348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "89",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6942,
      y: 453,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "90",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7002,
      y: 555,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "91",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7081,
      y: 622,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "92",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7210,
      y: 642,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "93",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7336,
      y: 579,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "94",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7403,
      y: 471,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "95",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7441,
      y: 359,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "96",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7507,
      y: 254,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "97",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7630,
      y: 209,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "98",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7766,
      y: 219,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "99",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7874,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "100",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7939,
      y: 402,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "101",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8027,
      y: 494,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "102",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8117,
      y: 573,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "103",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8235,
      y: 608,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "104",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8359,
      y: 574,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "105",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8428,
      y: 487,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "106",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8454,
      y: 397,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "107",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8472,
      y: 308,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "108",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8553,
      y: 244,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "109",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8661,
      y: 236,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "110",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8755,
      y: 301,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "111",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8839,
      y: 376,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "112",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8924,
      y: 450,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "113",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9035,
      y: 503,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "114",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9148,
      y: 502,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "115",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9241,
      y: 430,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "116",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9327,
      y: 353,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "117",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9417,
      y: 286,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "118",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9525,
      y: 238,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "119",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9638,
      y: 214,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "120",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9767,
      y: 233,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "121",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9809,
      y: 333,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "122",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9770,
      y: 419,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "123",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9745,
      y: 523,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "124",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9826,
      y: 595,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "125",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9945,
      y: 617,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "126",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10073,
      y: 621,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "127",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10185,
      y: 583,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "128",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10252,
      y: 492,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "129",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10381,
      y: 464,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "130",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10472,
      y: 524,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "131",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10584,
      y: 568,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "132",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10665,
      y: 496,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "133",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10703,
      y: 398,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "blue_node",
      parent: "3",
      data: ""
    },
    {
      id: "134",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "178",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "212",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "243",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "279",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "287",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "297",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "326",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "342",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "351",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "359",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "417",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "cropsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "4",
      data: ""
    },
    {
      id: "171",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "205",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "236",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "272",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "283",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "293",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "319",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "338",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "347",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "355",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "413",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorA",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "452",
      type: "Container",
      name: "",
      nameSpace: "",
      className: "signsSectorB",
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      parent: "5",
      data: ""
    },
    {
      id: "135",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 945,
      y: 68,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "136",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1232,
      y: 68,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "137",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 813,
      y: 85,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "138",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1099,
      y: 85,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "139",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 881,
      y: 153,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "140",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1020,
      y: 154,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "141",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1170,
      y: 156,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "142",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 743,
      y: 169,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "143",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 928,
      y: 218,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "144",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1157,
      y: 233,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "145",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 809,
      y: 248,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "146",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1042,
      y: 252,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "147",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 922,
      y: 296,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "148",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1028,
      y: 319,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "149",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1145,
      y: 329,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "150",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 905,
      y: 385,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "151",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1050,
      y: 391,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "152",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 623,
      y: 526,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "153",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 704,
      y: 576,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "154",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 553,
      y: 584,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "155",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 624,
      y: 634,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "156",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 760,
      y: 634,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "157",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 493,
      y: 641,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "158",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 411,
      y: 690,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "159",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 841,
      y: 693,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "160",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 682,
      y: 700,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "161",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 522,
      y: 718,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "162",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 960,
      y: 721,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "163",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 760,
      y: 748,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "164",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 627,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "165",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 411,
      y: 775,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "134",
      data: ""
    },
    {
      id: "166",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 858,
      y: 796,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "167",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1018,
      y: 798,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "168",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 539,
      y: 801,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "169",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 694,
      y: 811,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "134",
      data: ""
    },
    {
      id: "170",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 313,
      y: 817,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "134",
      data: ""
    },
    {
      id: "179",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1507,
      y: 42,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "180",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1697,
      y: 63,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "181",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1950,
      y: 72,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "182",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1820,
      y: 83,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "183",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1568,
      y: 86,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "184",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1450,
      y: 130,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "185",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1562,
      y: 134,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "186",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1675,
      y: 149,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "187",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1901,
      y: 151,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "188",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1795,
      y: 165,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "189",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1852,
      y: 229,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "190",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1501,
      y: 447,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "191",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1397,
      y: 484,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "192",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1548,
      y: 518,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "193",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1423,
      y: 581,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "194",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1527,
      y: 592,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "195",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1619,
      y: 610,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "196",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1491,
      y: 644,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "197",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1606,
      y: 685,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "198",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1386,
      y: 703,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "199",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1722,
      y: 708,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "200",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1496,
      y: 728,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "201",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1634,
      y: 789,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "202",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1760,
      y: 797,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_3",
      parent: "178",
      data: ""
    },
    {
      id: "203",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1380,
      y: 803,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_4",
      parent: "178",
      data: ""
    },
    {
      id: "204",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1513,
      y: 807,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_1",
      parent: "178",
      data: ""
    },
    {
      id: "213",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2270,
      y: 70,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "214",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2460,
      y: 92,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "215",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2201,
      y: 150,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "216",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2340,
      y: 150,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "217",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2499,
      y: 151,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "218",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2249,
      y: 207,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "219",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2122,
      y: 272,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "220",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2069,
      y: 370,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "221",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2374,
      y: 431,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "222",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2494,
      y: 438,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "223",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2542,
      y: 500,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "224",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2399,
      y: 523,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "225",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2609,
      y: 592,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "226",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2408,
      y: 602,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "227",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2630,
      y: 641,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "228",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2485,
      y: 669,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "229",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2319,
      y: 677,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "212",
      data: ""
    },
    {
      id: "230",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2676,
      y: 729,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "231",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2530,
      y: 732,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "232",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2374,
      y: 744,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "233",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2229,
      y: 776,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "234",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2650,
      y: 806,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "212",
      data: ""
    },
    {
      id: "235",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2485,
      y: 820,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "212",
      data: ""
    },
    {
      id: "244",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2975,
      y: 64,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "245",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2811,
      y: 100,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "246",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2974,
      y: 116,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "247",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3100,
      y: 146,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "248",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2719,
      y: 190,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "249",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3175,
      y: 195,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "250",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3060,
      y: 195,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_2",
      parent: "243",
      data: ""
    },
    {
      id: "251",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2920,
      y: 204,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "243",
      data: ""
    },
    {
      id: "252",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2757,
      y: 258,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "253",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3011,
      y: 272,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "254",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3155,
      y: 283,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "243",
      data: ""
    },
    {
      id: "255",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2864,
      y: 322,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "243",
      data: ""
    },
    {
      id: "256",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3163,
      y: 350,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "257",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3034,
      y: 387,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "258",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2892,
      y: 395,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "259",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3093,
      y: 439,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "260",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3491,
      y: 472,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "261",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2973,
      y: 505,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "262",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3372,
      y: 546,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "263",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3511,
      y: 552,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "264",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3358,
      y: 605,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "265",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3510,
      y: 646,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "266",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3295,
      y: 689,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "243",
      data: ""
    },
    {
      id: "267",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3536,
      y: 709,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "268",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3660,
      y: 751,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_3",
      parent: "243",
      data: ""
    },
    {
      id: "269",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3296,
      y: 764,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "270",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3785,
      y: 782,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_1",
      parent: "243",
      data: ""
    },
    {
      id: "271",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3439,
      y: 795,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_4",
      parent: "243",
      data: ""
    },
    {
      id: "280",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4048,
      y: 157,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "279",
      data: ""
    },
    {
      id: "281",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3833,
      y: 435,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "279",
      data: ""
    },
    {
      id: "282",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4188,
      y: 677,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "279",
      data: ""
    },
    {
      id: "288",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5203,
      y: 183,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "287",
      data: ""
    },
    {
      id: "289",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4421,
      y: 281,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "287",
      data: ""
    },
    {
      id: "290",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5006,
      y: 447,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "287",
      data: ""
    },
    {
      id: "291",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 5400,
      y: 650,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "287",
      data: ""
    },
    {
      id: "292",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4636,
      y: 680,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_3",
      parent: "287",
      data: ""
    },
    {
      id: "298",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6273,
      y: 65,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "299",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6454,
      y: 83,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "300",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6124,
      y: 130,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "301",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6538,
      y: 162,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_1",
      parent: "297",
      data: ""
    },
    {
      id: "302",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6254,
      y: 202,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_2",
      parent: "297",
      data: ""
    },
    {
      id: "303",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6416,
      y: 242,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "304",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6150,
      y: 300,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "305",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6327,
      y: 348,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "306",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6162,
      y: 430,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_2",
      parent: "297",
      data: ""
    },
    {
      id: "307",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6796,
      y: 434,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_2",
      parent: "297",
      data: ""
    },
    {
      id: "308",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6657,
      y: 493,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "309",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6304,
      y: 507,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "310",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6826,
      y: 519,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_1",
      parent: "297",
      data: ""
    },
    {
      id: "311",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6742,
      y: 633,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "312",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6917,
      y: 661,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "313",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6601,
      y: 679,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "314",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6835,
      y: 760,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "315",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6509,
      y: 824,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "316",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6976,
      y: 830,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "317",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6698,
      y: 833,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "297",
      data: ""
    },
    {
      id: "318",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6405,
      y: 2228,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "297",
      data: ""
    },
    {
      id: "327",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7380,
      y: 84,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "326",
      data: ""
    },
    {
      id: "328",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7087,
      y: 90,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_2",
      parent: "326",
      data: ""
    },
    {
      id: "329",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6942,
      y: 130,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "326",
      data: ""
    },
    {
      id: "330",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7231,
      y: 145,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "326",
      data: ""
    },
    {
      id: "331",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7379,
      y: 162,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_1",
      parent: "326",
      data: ""
    },
    {
      id: "332",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7053,
      y: 263,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "326",
      data: ""
    },
    {
      id: "333",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7339,
      y: 286,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "326",
      data: ""
    },
    {
      id: "334",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7198,
      y: 311,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_4",
      parent: "326",
      data: ""
    },
    {
      id: "335",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7103,
      y: 400,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_2",
      parent: "326",
      data: ""
    },
    {
      id: "336",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7310,
      y: 404,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_1",
      parent: "326",
      data: ""
    },
    {
      id: "337",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7196,
      y: 488,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.1,
        y: 1.1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_3",
      parent: "326",
      data: ""
    },
    {
      id: "343",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8003,
      y: 195,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "342",
      data: ""
    },
    {
      id: "344",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8256,
      y: 400,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "342",
      data: ""
    },
    {
      id: "345",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7668,
      y: 593,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "342",
      data: ""
    },
    {
      id: "346",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7923,
      y: 850,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "342",
      data: ""
    },
    {
      id: "352",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8918,
      y: 245,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "351",
      data: ""
    },
    {
      id: "353",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8680,
      y: 607,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "351",
      data: ""
    },
    {
      id: "354",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8950,
      y: 820,
      anchor: {
        x: 0.54,
        y: 0.94
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_3",
      parent: "351",
      data: ""
    },
    {
      id: "360",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9483,
      y: 41,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "361",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9225,
      y: 42,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "362",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9395,
      y: 57,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "363",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9731,
      y: 58,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "364",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9294,
      y: 61,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "365",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9181,
      y: 84,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "366",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9619,
      y: 87,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "367",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9528,
      y: 91,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "368",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9244,
      y: 109,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "369",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9421,
      y: 110,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "370",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9335,
      y: 115,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "371",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9667,
      y: 118,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "372",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9125,
      y: 143,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "373",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9556,
      y: 143,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "374",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9471,
      y: 148,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "375",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9205,
      y: 155,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "376",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9275,
      y: 168,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "377",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9367,
      y: 176,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "378",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9419,
      y: 204,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "379",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9228,
      y: 208,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "380",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9149,
      y: 209,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "381",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9309,
      y: 236,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "382",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9184,
      y: 277,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "383",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9259,
      y: 298,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "384",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9600.53251763825,
      y: 375.7006403415155,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "385",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9455.054147374514,
      y: 423.6077908217717,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "386",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9616.498881274614,
      y: 449.40394877267886,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "387",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9516.463238283606,
      y: 451.86072572038427,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "388",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9369,
      y: 507,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "389",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9437.81182120197,
      y: 515.7369263607258,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "390",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9517.899284201145,
      y: 525.5640341515475,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "391",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9602,
      y: 529,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "392",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9283.265149461284,
      y: 588.2118463180364,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "393",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9365.349093929244,
      y: 590.6686232657418,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "394",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9448.237972183706,
      y: 596.8105656350054,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "395",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9529.81813594759,
      y: 604.1808964781217,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "396",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9213,
      y: 637,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "397",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9572.911821201975,
      y: 658.2299893276414,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "398",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9376.774495385172,
      y: 661.9151547491996,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "399",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9280.6045484747,
      y: 668.0570971184633,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "400",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9455.607063092797,
      y: 679.1125933831378,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "401",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9490.149022566231,
      y: 728.2481323372466,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "402",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9213,
      y: 717,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "403",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9370.633586294261,
      y: 740.5320170757739,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "404",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9679,
      y: 741,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "405",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9586.421821201975,
      y: 742.9887940234793,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "406",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9258.869040839716,
      y: 758.9578441835646,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "407",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9623,
      y: 785,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "359",
      data: ""
    },
    {
      id: "408",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9720.497876734016,
      y: 788.4391675560299,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "409",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9809.843590493047,
      y: 790.8959445037354,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "410",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9521.220863220315,
      y: 793.3527214514409,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "411",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9318,
      y: 795,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "359",
      data: ""
    },
    {
      id: "412",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9423.62677388749,
      y: 831.0869797225187,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "359",
      data: ""
    },
    {
      id: "418",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10371.740909090908,
      y: 139.85005336179296,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "419",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10094.171818181816,
      y: 145.9919957310566,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "420",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10297.185521660136,
      y: 148.44877267876205,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "417",
      data: ""
    },
    {
      id: "421",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10155.580909090906,
      y: 159.5042689434365,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "422",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10209.620909090909,
      y: 168.1029882604056,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "423",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10400.352794387409,
      y: 196.35592315901818,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "424",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10037.675454545453,
      y: 223.38046958377805,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "425",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10455.257272727273,
      y: 227.06563500533622,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "426",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10101.540909090909,
      y: 231.9791889007471,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "417",
      data: ""
    },
    {
      id: "427",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10307.01097620559,
      y: 249.17662753468522,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "428",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10235.776430751044,
      y: 254.0901814300961,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "429",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10161.721818181817,
      y: 270.05923159018147,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "430",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10404.901818181817,
      y: 295.85538954108864,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "431",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9991.004545454543,
      y: 298.31216648879405,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "432",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10473.68,
      y: 303.2257203842049,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "433",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10266.48097620559,
      y: 305.6824973319104,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "434",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10334.030976205591,
      y: 311.824439701174,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "417",
      data: ""
    },
    {
      id: "435",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10048.729090909092,
      y: 331.4786552828175,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "436",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10189.105521660136,
      y: 332.70704375667026,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "437",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10529,
      y: 333,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "438",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10119.963636363636,
      y: 337.6205976520812,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "439",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9948.018181818183,
      y: 380.61419423692644,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "440",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10355.774545454544,
      y: 380.61419423692644,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "441",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10501,
      y: 384,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "442",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10429.465454545454,
      y: 395.3548559231591,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "443",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10004.514545454545,
      y: 396.58324439701175,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "444",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10282.083636363635,
      y: 405.18196371398085,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "417",
      data: ""
    },
    {
      id: "445",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10209.620909090907,
      y: 415.0090715048026,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "446",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10064.695454545454,
      y: 429.74973319103526,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "447",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10128.56090909091,
      y: 449.40394877267886,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "448",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9913.62909090909,
      y: 455.54589114194243,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "449",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9970.125454545452,
      y: 475.2001067235859,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_4",
      parent: "417",
      data: ""
    },
    {
      id: "450",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10021.70909090909,
      y: 518.1937033084312,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_2",
      parent: "417",
      data: ""
    },
    {
      id: "451",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10081.89,
      y: 530.4775880469584,
      anchor: {
        x: 0.49,
        y: 0.97
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_3",
      parent: "417",
      data: ""
    },
    {
      id: "172",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 669,
      y: 643,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "171",
      data: ""
    },
    {
      id: "175",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 933,
      y: 173,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "171",
      data: ""
    },
    {
      id: "206",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1828,
      y: 104,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "205",
      data: ""
    },
    {
      id: "209",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 1500,
      y: 561,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "205",
      data: ""
    },
    {
      id: "237",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2474,
      y: 526,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "236",
      data: ""
    },
    {
      id: "240",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2090,
      y: 255,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "236",
      data: ""
    },
    {
      id: "273",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 2953,
      y: 300,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "272",
      data: ""
    },
    {
      id: "276",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3416,
      y: 615,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "272",
      data: ""
    },
    {
      id: "284",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 3884,
      y: 162,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "283",
      data: ""
    },
    {
      id: "294",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 4980,
      y: 120,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "293",
      data: ""
    },
    {
      id: "320",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6200,
      y: 150,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "319",
      data: ""
    },
    {
      id: "323",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 6800,
      y: 600,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "319",
      data: ""
    },
    {
      id: "339",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 7100,
      y: 190,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "338",
      data: ""
    },
    {
      id: "348",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8180,
      y: 140,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "347",
      data: ""
    },
    {
      id: "356",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 8840,
      y: 540,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "355",
      data: ""
    },
    {
      id: "414",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 9350,
      y: 580,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "413",
      data: ""
    },
    {
      id: "453",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 10189,
      y: 232,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "crop-sign",
      parent: "452",
      data: ""
    },
    {
      id: "173",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "172",
      data: ""
    },
    {
      id: "174",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_harvest_map",
      parent: "172",
      data: ""
    },
    {
      id: "176",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "175",
      data: ""
    },
    {
      id: "177",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_harvest_map",
      parent: "175",
      data: ""
    },
    {
      id: "207",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "206",
      data: ""
    },
    {
      id: "208",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_harvest_map",
      parent: "206",
      data: ""
    },
    {
      id: "210",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "209",
      data: ""
    },
    {
      id: "211",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "strawberry_harvest_map",
      parent: "209",
      data: ""
    },
    {
      id: "238",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "237",
      data: ""
    },
    {
      id: "239",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_harvest_map",
      parent: "237",
      data: ""
    },
    {
      id: "241",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "240",
      data: ""
    },
    {
      id: "242",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_harvest_map",
      parent: "240",
      data: ""
    },
    {
      id: "274",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "273",
      data: ""
    },
    {
      id: "275",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_harvest_map",
      parent: "273",
      data: ""
    },
    {
      id: "277",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "276",
      data: ""
    },
    {
      id: "278",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "watermelon_harvest_map",
      parent: "276",
      data: ""
    },
    {
      id: "285",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "284",
      data: ""
    },
    {
      id: "286",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_harvest_map",
      parent: "284",
      data: ""
    },
    {
      id: "295",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "294",
      data: ""
    },
    {
      id: "296",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -26,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "orange_harvest_map",
      parent: "294",
      data: ""
    },
    {
      id: "321",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "320",
      data: ""
    },
    {
      id: "322",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_harvest_map",
      parent: "320",
      data: ""
    },
    {
      id: "324",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "323",
      data: ""
    },
    {
      id: "325",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_harvest_map",
      parent: "323",
      data: ""
    },
    {
      id: "340",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "339",
      data: ""
    },
    {
      id: "341",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: -45,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "artichoke_harvest_map",
      parent: "339",
      data: ""
    },
    {
      id: "349",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: 20,
      y: 25,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "348",
      data: ""
    },
    {
      id: "350",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_harvest_map",
      parent: "348",
      data: ""
    },
    {
      id: "357",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "356",
      data: ""
    },
    {
      id: "358",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "cherry_harvest_map",
      parent: "356",
      data: ""
    },
    {
      id: "415",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "414",
      data: ""
    },
    {
      id: "416",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_harvest_map",
      parent: "414",
      data: ""
    },
    {
      id: "454",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -20,
      y: -72,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "speech_bubble",
      parent: "453",
      data: ""
    },
    {
      id: "455",
      type: "Sprite",
      name: "",
      nameSpace: "",
      className: "",
      x: -5,
      y: -24,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.7,
        y: 0.7
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: "None"
      },
      texture: "carrot_harvest_map",
      parent: "453",
      data: ""
    }
  ]
} as const;

export class WorldLayout2 {
  static raw = raw;
  root: GameObject<PIXI.Container>;
  backgrounds: GameObject<PIXI.Container>;
  nodesContainer: GameObject<PIXI.Container>;
  cropsSectorA: (GameObject<PIXI.Container>)[];
  cropsSectorB: (GameObject<PIXI.Container>)[];
  signsSectorA: (GameObject<PIXI.Container>)[];
  signsSectorB: (GameObject<PIXI.Container>)[];

  constructor() {
    populate(this, raw);
  }
}
